module.exports = __webpack_public_path__ + "static/media/processImg1.669c4d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/processImg1.png
// module id = 261
// module chunks = 0